import { MaterialIcons, MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import { cssInterop } from "react-native-css-interop";

cssInterop(IconM, {
  className: {
    target: 'style',
    nativeStyleToProp: {
      color: true,
      size: true,
      position: true,
      right: true,
      top: true,
      p: true,
    },
  },
})

cssInterop(IconMC, {
  className: {
    target: 'style',
    nativeStyleToProp: {
      color: true,
      size: true,
      position: true,
      right: true,
      top: true,
      p: true,
    },
  },
})

cssInterop(IconI, {
  className: {
    target: 'style',
    nativeStyleToProp: {
      color: true,
      size: true,
      position: true,
      right: true,
      top: true,
      p: true,
    },
  },
})

export function IconM(props) {
  return <MaterialIcons {...props} />
}
export function IconMC(props) {
  return <MaterialCommunityIcons {...props} />
}

export function IconI(props) {
  return <Ionicons {...props} />
}

